import { detractors, promoters } from '../constants/constants';

export const FeedbackTableRow = ({ item, allKeys, index }) => {
  return (
    <tr key={`row-${index}`} className="bg-gray-800 text-white">
      {allKeys.map((key, i) => (
        <td
          style={{ textAlign: 'center' }}
          className="group text-center capitalize border-b p-2 text-sm border-[#757575]"
          key={`${index}_${key}_cell_${i}`}
        >
          {key === 'NPS' ? (
            <span
              style={{
                backgroundColor: promoters.includes(item[key])
                  ? '#4CAF50'
                  : detractors.includes(item[key])
                  ? '#F44336'
                  : '#FF9800',
              }}
              className={`rounded-lg text-white px-2 py-1 `}
            >
              {item[key]}
            </span>
          ) : (
            <span>
              {key === 'Feedback' && item[key]?.length > 100
                ? `${item[key].slice(0, 100)}...`
                : item[key] !== undefined
                ? item[key]
                : 'NA'}
            </span>
          )}
        </td>
      ))}
    </tr>
  );
};
